import React from 'react';
import {SocialLink} from 'app/components/socialLink';

export const data = {
  mainHeader: {
    image: {
      basicName: 'banner-top',
      alt: 'Interwetten 11 des Jahres - Wir machen dich zum Profi! So sind wir.',
    },
  },
  topEleven1: {
    header: 'Erste Elf',
  },
  topEleven2: {
    header: 'Zweite Elf',
  },
  substitutes: {
    header: 'Ersatzbank',
  },
  bottomHeader: {
    image: {
      basicName: 'banner-bottom-v2',
      alt: 'Interwetten - Offizieller Partner von Borussia Mönchengladbach',
    },
  },
  infoCard1: {
    heading: 'Dein direkter Aufstieg in die Bundesliga!',
    content: [
      <React.Fragment key='card1'>
        <SocialLink link='https://www.interwetten.de/de/sportwetten' label='Interwetten' /> und FuPa präsentieren die
        Elf des Jahres! Kick dich rein und erlebe deinen „FuPa like a Pro“.
        <br />
        Zusammen mit Interwetten-Partner Borussia Mönchengladbach darfst du dich einmal wie ein echter Bundesliga-Profi
        fühlen – mit allem, was dazugehört: Unterbringung, Regeneration, professionelles Training, Meet & Greet und
        einem großen Abschlussspiel vor deinen Fans. Natürlich alles auf Profi-Niveau!
      </React.Fragment>,
    ],
    image: {
      basicName: 'card1',
      alt: 'Die Kurve im Borussia-Park ist heiß auf das Spiel der 11 des Jahres',
    },
  },
  informationBanner: 'Das Spiel des Jahres fand am 22.07.2023 am BORUSSIA PARK statt!',
  link: 'https://www.fupa.net/match/erste-elf-1180931-zweite-elf-1180932-230722',
  infoCard2: {
    heading: 'Deine Performance zählt – und zwar jeden Spieltag!',
    content: [
      <React.Fragment key='card2'>
        Egal, ob schneller Flügelflitzer, stabiler 6er, ein klassischer 10er oder Torwart – jeder hat die Chance, sich
        in die Elf des Jahres zu spielen!
        <br />
        Aus allen Amateur-Mannschaften der FuPa-Community suchen wir 22 Spieler (2 Keeper, 6 Verteidiger, 8
        Mittelfeldspieler, 6 Stürmer), die sich am Ende der Saison die Krone aufsetzen. Je öfter du dich mit deiner
        Leistung in die Elf der Woche spielst, desto höher deine Chance, nominiert zu werden.
      </React.Fragment>,
    ],
    catchPhrase: 'Checke jede Woche deine Performance!',
    image: {
      basicName: 'card2',
      alt: 'Jonas Hofmann, Spieler von Borussia Mönchengladbach, beim Eckball im Borussia-Park',
    },
  },
};
